export default "__VITE_ASSET__C92ixCf4__"